import bg from "../assets/images/home-bg.png";
import image40 from "../assets/images/40-step.jpg";
import image50 from "../assets/images/50-step.jpg";
import { InformationForm } from "../components/Registration/InformationForm";
import Modal from 'react-modal';
import { Contract } from "../components/Registration/Contract";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const customStyles = {
    content: {
        top: '30%',
        left: '30%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-30%',
        transform: 'translate(-30%, -30%)',
        outerHeight: '100px',
        border: 'solid blue 1px',
        borderRadius: '20px',
        backgroundColor: '#fff'
    },
};

export const Registration = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    
    const [registrations, setRegistrations] = useState([]);
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        address: '',
        phone: '',
        email: '',
        time: 0,        //months or appointments per week(kids fitness)
        timings: '',    //for kids fitness
        days: [],       //for kits fitness
        totalAmount: 0,
        payableAmount: 0,
        discount: 0,
        kidEntries: 0,
        swimmingExpertise: '',
        healthProblems: null,
        healthProblemDescription: '',
        type: 'Individual',
        premium: false,
        batchId: '0',
        paymentMethod: '',
        entries: '',
        ageGroup: '',
        age: 0,
        gender: ""
    });

   
    
    
    const [modalIsOpen, setIsOpen] = useState(false);
    function openModal() {
        setIsOpen(true);
    }
    function closeModal() {
        setIsOpen(false);
    }

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user) {
            setFormData({ ...formData, email: user.email });
        } else {
            openModal();
        }
    }, []);

    const [form, setForm] = useState("Individual");

    return (
        <div className="mt-40 font-custom2">
            <div className="flex flex-col items-center justify-center px-20 md:min-h-screen">
                <img src={bg} alt="bg"
                    className="min-w-[100vw] min-h-[30vh] md:min-h-[100vh] block absolute top-0 left-0 -z-10 " />
                {/* Black Friday Banner */}
                <div className={`mt-10 sm:mt-20 md:mt-0 max-w-[95vw] ${step === 1 ? 'block' : 'hidden'}`}>
                    {/* <div className="bg-gradient-to-r from-red-600 via-red-700 to-black text-white text-center py-4 px-6 rounded-t-3xl mb-0 shadow-2xl relative z-10">
                        <div className="flex flex-col items-center gap-2">
                            <h2 className="text-3xl md:text-4xl font-bold animate-pulse">BLACK FRIDAY SALE</h2>
                            <p className="text-xl md:text-2xl font-semibold">Zbritje deri në 50%</p>
                          
                        </div>
                    </div> */}
                    {/* Images Section */}
                    {/* <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center py-4 sm:py-6 px-4 sm:px-6 bg-white rounded-b-3xl shadow-2xl relative z-10">
                        <img 
                            src={image40} 
                            alt="Step 40" 
                            onClick={() => {
                                setForm("Shkolla e Notit");
                                setFormData((prevData) => ({
                                    ...prevData,
                                    type: "Shkolla e Notit",
                                    ageGroup: "children",
                                    time: 6,
                                    entries: "3 Hyrje në Javë - 12 Hyrje në Muaj",
                                    totalAmount: 162,
                                    payableAmount: 162,
                                    discount: 0
                                }));
                            }}
                            className="w-full sm:w-auto max-w-[90%] sm:max-w-none h-auto sm:h-[200px] md:h-[250px] lg:h-[300px] object-contain sm:object-cover rounded-lg shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer"
                        />
                        <img 
                            src={image50} 
                            alt="Step 50" 
                            onClick={() => {
                                setForm("Individual");
                                setFormData((prevData) => ({
                                    ...prevData,
                                    type: "Individual",
                                    premium: false,
                                    time: 12,
                                    entries: 96,
                                    totalAmount: 170,
                                    payableAmount: 170,
                                    discount: 0
                                }));
                            }}
                            className="w-full sm:w-auto max-w-[90%] sm:max-w-none h-auto sm:h-[200px] md:h-[250px] lg:h-[300px] object-contain sm:object-cover rounded-lg shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer"
                        />
                    </div> */}
                    <div className="relative -mt-1">
                        <InformationForm step={step} setStep={setStep} formData={formData} setFormData={setFormData} setRegistrations={setRegistrations} registrations={registrations} form={form} setForm={setForm}/>
                    </div>
                </div>
                <div className={`mt-10 sm:mt-20 md:mt-0 max-w-[95vw] ${step === 2 ? 'block' : 'hidden'}`}>
                    <Contract step={step} setStep={setStep} formData={formData} registrations={registrations} setRegistrations={setRegistrations} setFormData={setFormData} form={form} setForm={setForm}/>
                </div>
              
                {/* <Modal
                    isOpen={modalIsOpen}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
 <div className="flex flex-col items-center justify-center gap-10 p-5 px-10 max-w-[600px] text-center" style={{backgroundColor: '#fff'}}>
                        <h className='text-xl font-bold'  style={{ textAlign: 'center' }}>{t('choose_service')}</h>
                        <h className='text-xl font-bold'  style={{ textAlign: 'center' }}>{t('choose_service1')}</h>
                        <div className="flex flex-row gap-5">
                         
                            <button onClick={async () => {
                                closeModal();
                                navigate('/login')
                            }} className="p-2 px-10 transition-all duration-200 border-2 border-blue-500 rounded-xl hover:bg-blue-500">{t('login')}</button>
                        </div>
                    </div>
                </Modal> */}

            </div>
        </div>
    );
};
